export enum NutriScoreCategoryBaseIngredientCategory {
	StandardFood = 'StandardFood',
	DriedFood = 'DriedFood',
	StandardBeverage = 'StandardBeverage',
	ConcentradedBeverage = 'ConcentradedBeverage',
}
